import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { parse } from 'node-html-parser';

import { YoureDoingSomeThingWrong, ServerSideRendered } from '../assets/components';

export function WPParagraph({ data, ...rest }) {
  const { rendered } = data;
  const [message, setMessage] = useState('');

  const Tag = `div`;
  const blockClass = `wp-block-paragraph`;

  const blockClasses = classnames(blockClass, {});

  useEffect(() => {
    const parsed = parse(rendered);
    const rawText = parsed.rawText.trim();

    if (rawText === ``) {
      setMessage(`please remove empty paragraphs`);
      return;
    }

    if (rawText.includes('[') && rawText.includes('/]')) {
      setMessage(`please use Shortcode block for shortcodes`);
      return;
    }

    setMessage(``);
  }, [rendered]);

  // console.log(message);

  return (
    <>
      {message !== `` ? (
        <Tag className={blockClasses}>
          <YoureDoingSomeThingWrong repeat={2} withHeader={false} tip={message} />
        </Tag>
      ) : (
        <ServerSideRendered data={data} />
      )}
    </>
  );
}
